
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="adr?.pays" [label]="step5.getpays"
[type]="'select'"
[typeSelect]="optionsSelectType" [optionsWithCode]="optionsSelect"	[rule]="'pattern_25'" [name]="paysCtrlName">
</app-form-input>
<app-type-voie *ngIf="isFr()" [uid]="getUid() + '_voie'" [errorMessage]="{'required' : 'ctr_263'}" [parentForm]="parentForm" [disabled]="disabled"
    [voie]="adr?.voie" [rule]="rule"></app-type-voie>
<app-type-voie *ngIf="!isFr()" [uid]="getUid() + '_voiee'" [errorMessage]="{'required' : 'ctr_263'}" [parentForm]="parentForm" [disabled]="disabled"
    [voie]="adr?.voie_e" [rule]="rule"></app-type-voie>
<app-form-input *ngIf="isFr()" [parentForm]="parentForm" [errorMessage]="{'required' : 'ctr_105', 'pattern' : 'ctr_1156'}" [disabled]="disabled" [value]="adr?.cp" [label]="step5.getcp"
    [type]="'text'" [rule]="rule + 'pattern_3'" [name]="getUid() + '_SepAtt_cp'">
</app-form-input>
<app-form-input *ngIf="!isFr()" [parentForm]="parentForm" [errorMessage]="{'required' : 'ctr_105'}" [disabled]="disabled" [value]="adr?.cp_e"
    [label]="step5.getcp" [type]="'text'" [rule]="rule + 'pattern_31|minSize_1|maxSize_10'" [name]="getUid() + '_SepAtt_cp_e'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="adr?.ville" [label]="step5.getville"
    [type]="'text'" [rule]="rule + 'maxSize_100|pattern_21'" [errorMessage]="{'required' : 'ctr_92'}" [name]="getUid() + '_SepAtt_ville'">
</app-form-input>
